import React from "react";
import {TextField} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";

const NodeFilters = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="user-filters">
        <div className="field">
            <TextField
                label="First Name"
                type="text"
                value={forms.sanitizeValue(data.firstName)}
                onChange={(event) => onChange("firstName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Last Name"
                type="text"
                value={forms.sanitizeValue(data.lastName)}
                onChange={(event) => onChange("lastName", event.target.value)}
            />
        </div>
    </div>
}

export default NodeFilters;
